import { supabase } from '../../src/lib/supabase';

// Progresso do Academy: uma linha por aula concluída (academy_progresso, RLS só do
// próprio usuário). Falha de leitura ou gravação não trava o curso — o vídeo
// continua tocando e a marcação vale só nesta sessão.

export async function carregarConcluidas(): Promise<Set<string>> {
    const { data, error } = await supabase.from('academy_progresso').select('aula_id');
    if (error) {
        console.warn('Academy: não foi possível ler o progresso.', error.message);
        return new Set();
    }
    return new Set((data || []).map((l: { aula_id: string }) => l.aula_id));
}

export async function marcarConcluida(aulaId: string): Promise<boolean> {
    const { error } = await supabase
        .from('academy_progresso')
        .upsert({ aula_id: aulaId }, { onConflict: 'user_id,aula_id', ignoreDuplicates: true });
    if (error) console.warn('Academy: não foi possível salvar o progresso.', error.message);
    return !error;
}

export async function desmarcarConcluida(aulaId: string): Promise<boolean> {
    const { error } = await supabase.from('academy_progresso').delete().eq('aula_id', aulaId);
    if (error) console.warn('Academy: não foi possível desfazer a aula concluída.', error.message);
    return !error;
}

/** URLs assinadas (6 h) dos arquivos do curso; caminho sem arquivo publicado fica de fora. */
export async function assinarArquivos(bucket: string, caminhos: string[]): Promise<Record<string, string>> {
    const { data, error } = await supabase.storage.from(bucket).createSignedUrls(caminhos, 60 * 60 * 6);
    if (error || !data) {
        console.warn('Academy: não foi possível abrir os arquivos do curso.', error?.message);
        return {};
    }
    const urls: Record<string, string> = {};
    for (const item of data) {
        if (item.path && item.signedUrl && !item.error) urls[item.path] = item.signedUrl;
    }
    return urls;
}
